<template>
    <div>
      <p>Picked the wrong subscription? Shop around then come back to pay!</p>
    </div>
</template>
<script>
export default {
    name: 'products'
}
</script>
